module.exports = __webpack_public_path__ + "img/suit-06.004a626d.png";